import { useQuery } from '@tanstack/react-query';
import { useAuthenticationContext } from 'Foundation/Authentication';
import { getMasterPoolPreimumBreakdown } from '../../HbtMasterPool/ValidationInventoryService';
import { MasterPoolPremiumsAndTaxes } from '../types';

export const useMasterPoolPremiumsBreakdown = (masterPoolCmhcAccountNumber: string) => {
  const authContext = useAuthenticationContext();

  return useQuery<MasterPoolPremiumsAndTaxes[] | null, Error>({
    queryKey: ['masterPoolPremiumsBreakdown', masterPoolCmhcAccountNumber],
    queryFn: async () => {
      const result = await getMasterPoolPreimumBreakdown(masterPoolCmhcAccountNumber, authContext);

      if (!result) {
        throw new Error('no_data_error');
      }

      return result;
    }
  });
};
